import type { SessionBrowserId, SessionOsId } from './sessionClientDisplay';

/** [Iconify](https://iconify.design/) `logos` collection — maintained third-party brand marks */
export const SESSION_BROWSER_ICONIFY: Record<SessionBrowserId, string> = {
  chrome: 'logos:chrome',
  firefox: 'logos:firefox',
  safari: 'logos:safari',
  edge: 'logos:microsoft-edge',
  opera: 'logos:opera',
  unknown: 'logos:chromium',
};

export const SESSION_OS_ICONIFY: Record<SessionOsId, string> = {
  windows: 'logos:microsoft-windows-icon',
  macos: 'logos:apple',
  ios: 'logos:apple',
  android: 'logos:android-icon',
  linux: 'logos:ubuntu',
  unknown: 'logos:linux-tux',
};
